<template>
  <div class="work-parcel-item" :class="containerClass">
    <input v-model="item.name" class="form-control flex-4" disabled/>
    <input v-model="item.surface_worked" class="form-control flex-1" v-on:keydown="onlyNumbers" :disabled="item.has_batch"/> ha
  </div>
</template>
<script>
import {only_numbers} from "@/helpers/common";
export default {
  name: 'WorkParcelItem',
  props: ['data', 'containerClass'],
  data() {
    return {
      item: this.data ?? {},
    }
  },
  methods: {
    onlyNumbers(event) {
      return only_numbers(event);
    },
  },
  watch: {
    data: {
      handler: function (newVal) {
        this.item = newVal;
      },
      deep: true,
    }
  }
}
</script>
